const config = {
  email: "compliance@unibocconi.it",
  courseLink:
    "https://blackboard.unibocconi.it/webapps/login/?new_loc=/webapps%2Fportal%2Fexecute%2Ftabs%2FtabAction%3Ftab_tab_group_id%3D_143_1"
};

export default config;
